import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

// Style 
import * as S from './style';

export interface TagsProps {
    subjects?: (string | undefined)[];
    parent?: {
        title: string;
    };
    related_category?: string;
    theme?: string
}

const Tags: React.FC<TagsProps> = ({ subjects, parent, related_category, theme }) => {
    const category = related_category ? related_category : parent && parent.title.toLowerCase().replace(' ', '-');
    const tags = subjects ? subjects.filter(tag => tag !== undefined) : []
    const [isCaseStudy, setIsCaseStudy] = useState(false);
    const location = useLocation();
  
    useEffect(() =>{
        const caseStudy = location.pathname.includes("/case-study");

        if(caseStudy){
            setIsCaseStudy(true);
        } else {
            setIsCaseStudy(false);
        }

    }, [location.pathname.includes("/case-study")]);
    return (
        <S.Tags>
            <div className="tags">
                {category && !isCaseStudy &&(
                    <Link className={`category category-${category}`} to={`/${category}`}>
                        {category.replace('-', ' ')}
                    </Link>
                )}
                  {isCaseStudy && tags.length > 0 ? (
                    <S.Link to={`/tag/${tags[0]}`} className='tag'>
                        {tags[0]}
                    </S.Link>
                ) : (
                    tags.map((tag, i) => (
                        <Link key={tag! + i} to={`/tag/${tag}`} className='tag'>
                            #{tag}
                        </Link>
                    ))
                )}
            </div>
        </S.Tags>
    )
}

export default Tags;